// extracted by mini-css-extract-plugin
export default {"arPopup":"ArPopup_arPopup__HoEzH","popup":"ArPopup_popup__XqVZF","closeButton":"ArPopup_closeButton__Njez+","rotating":"ArPopup_rotating__s+7rA","appear":"ArPopup_appear__1x2kD"};